// eslint-disable-next-line import/no-cycle
import { ControlType, type ControlProps } from '../../index';
import { isNil } from '../../../../Utilities';

export const hasValues = (subControls: ControlProps[]): boolean =>
  subControls.some((item) => {
    switch (item.control) {
      case ControlType.SLIDER:
      case ControlType.EXTERNAL:
        return item.value.min !== item.default.min || item.value.max !== item.default.max;
      case ControlType.LISTBOX:
      case ControlType.SEARCH_LIST:
        return Array.isArray(item.value) && item.value.length > 0;
      default:
        return !isNil(item.value) && item.value !== item.default;
    }
  });
